import { 
  Calendar, 
  CheckCircle, 
  AlertTriangle, 
  FileText,
  Download,
  Trash2
} from 'lucide-react'

// Mock data - will be replaced with real API calls
const scanHistory = [
  {
    id: '1',
    date: new Date('2026-01-16T10:30:00'),
    type: 'Full System Scan',
    status: 'good',
    issues: 0,
    duration: '2m 34s',
  },
  {
    id: '2',
    date: new Date('2026-01-15T14:22:00'),
    type: 'Quick Scan',
    status: 'warning',
    issues: 2,
    duration: '45s',
  },
  {
    id: '3',
    date: new Date('2026-01-14T09:15:00'),
    type: 'Full System Scan',
    status: 'good',
    issues: 0,
    duration: '2m 12s',
  },
  {
    id: '4',
    date: new Date('2026-01-12T16:45:00'),
    type: 'Security Scan',
    status: 'good',
    issues: 0,
    duration: '1m 08s',
  },
  {
    id: '5',
    date: new Date('2026-01-10T11:00:00'),
    type: 'Full System Scan',
    status: 'warning',
    issues: 3,
    duration: '2m 45s',
  },
]

export function HistoryPage() {
  return (
    <div className="p-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Scan History</h1>
        <p className="text-slate-400">
          View your past diagnostic scans and their results
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="card">
          <div className="text-sm text-slate-400 mb-1">Total Scans</div>
          <div className="text-2xl font-bold text-white">{scanHistory.length}</div>
        </div>
        <div className="card">
          <div className="text-sm text-slate-400 mb-1">Issues Fixed</div>
          <div className="text-2xl font-bold text-health-good">12</div>
        </div>
        <div className="card">
          <div className="text-sm text-slate-400 mb-1">Last Scan</div>
          <div className="text-2xl font-bold text-white">Today</div>
        </div>
      </div>

      {/* History List */}
      <div className="space-y-4">
        {scanHistory.map((scan) => (
          <div key={scan.id} className="card hover:bg-slate-800/70 transition-colors">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                  scan.status === 'good' ? 'bg-health-good/20' : 'bg-health-warning/20'
                }`}>
                  {scan.status === 'good' 
                    ? <CheckCircle className="w-5 h-5 text-health-good" />
                    : <AlertTriangle className="w-5 h-5 text-health-warning" />
                  }
                </div>
                <div>
                  <h3 className="font-medium text-white">{scan.type}</h3>
                  <div className="flex items-center gap-3 text-sm text-slate-400">
                    <span className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {scan.date.toLocaleDateString()} at {scan.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </span>
                    <span>•</span>
                    <span>{scan.duration}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <div className={`text-sm font-medium ${
                    scan.issues === 0 ? 'text-health-good' : 'text-health-warning'
                  }`}>
                    {scan.issues === 0 ? 'No issues' : `${scan.issues} issue${scan.issues > 1 ? 's' : ''} found`}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button className="p-2 hover:bg-slate-700 rounded-lg transition-colors" title="View Report">
                    <FileText className="w-4 h-4 text-slate-400" />
                  </button>
                  <button className="p-2 hover:bg-slate-700 rounded-lg transition-colors" title="Download">
                    <Download className="w-4 h-4 text-slate-400" />
                  </button>
                  <button className="p-2 hover:bg-slate-700 rounded-lg transition-colors" title="Delete">
                    <Trash2 className="w-4 h-4 text-slate-400" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Load More */}
      <div className="mt-6 text-center">
        <button className="btn-secondary">
          Load More History
        </button>
      </div>
    </div>
  )
}
